<span>{{ 'history.entities.measure' | transloco }} "{{ entityName() }}", "{{ attributeName() }}" : </span>
<ces-value-change [detail]="detail()" />
